import { render, staticRenderFns } from "./MomoError.vue?vue&type=template&id=081c246e&"
import script from "./MomoError.vue?vue&type=script&lang=ts&"
export * from "./MomoError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports